import { QueryFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from 'src/services/utils/enhancedAuthTokenHttp';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';

export const rolesQueryKeyRoot = '/shared/roles' as const;

export interface ListRolesParams {
  includePermissions?: boolean;
}

export interface ListRolesResponse {
  success: boolean;
  roles: Role[];
}

export interface Role {
  id: string;
  name: string;
  description: string | null;
  isSystem?: boolean;
  tenantId?: string | null;
  createdAt: string;
  updatedAt: string;
  permissions?: string[];
}

const listRoles: QueryFunction<
  ListRolesResponse,
  [typeof rolesQueryKeyRoot, string | null, ListRolesParams]
> = async ({ queryKey }) => {
  if (isMockServices()) return await mock(_mockData);

  const { includePermissions } = queryKey[2];
  const authTokenHttp = await getCompatibleAuthTokenHttp();

  let url = '/shared/roles';
  if (includePermissions) {
    url += '?includePermissions=true';
  }

  const response = await authTokenHttp<ListRolesResponse>(url, {
    method: 'GET',
  });

  if (response.data) return response.data;
  throw new Error('Failed to fetch roles');
};

export default listRoles;

const _mockData: ListRolesResponse = {
  success: true,
  roles: [
    {
      id: 'mock-1',
      name: 'Admin',
      description: 'Administrator role with full access',
      isSystem: true,
      tenantId: null,
      createdAt: '2025-01-01T00:00:00Z',
      updatedAt: '2025-01-01T00:00:00Z',
      permissions: ['loan.view_all', 'tenant.manage', 'user.manage'],
    },
    {
      id: 'mock-2',
      name: 'User',
      description: 'Standard user role',
      isSystem: false,
      tenantId: 'mock-tenant-id',
      createdAt: '2025-01-01T00:00:00Z',
      updatedAt: '2025-01-01T00:00:00Z',
      permissions: ['loan.view_assigned'],
    },
  ],
};
